import React, { useCallback, useRef, useState } from "react";
import { HexColorPicker, HexColorInput } from "react-colorful";

import useClickOutside from "./useClickOutside";
import "./styles.css";

const ColorPickerFab = ({ color = "#005AA9", onChange, text = "Edit Color" }) => {
  const popover = useRef();
  const [isOpen, toggle] = useState(false);

  const close = useCallback(() => toggle(false), []);
  useClickOutside(popover, close);

  return (
    <div className="color-picker-fab-wrapper">
      <div className="picker">
        <div
          className="swatch"
          style={{ backgroundColor: color }}
          onClick={() => toggle(true)}
        />
        {isOpen && (
          <div className="popover custom-layout" ref={popover}>
            <HexColorPicker color={color} onChange={onChange} />
            <HexColorInput color={color} onChange={onChange} />
          </div>
        )}
      </div>
      <div className="color-picker-fab-wrapper-text">{text}</div>
    </div>
  );
};

export default ColorPickerFab;
